
jQuery(document).ready(function($) {

    const select = document.getElementById("backgroundSelect");
    if (select) {
        select.addEventListener("change", (event) => {
            const value = event.target.value;

            if (value === 'custom') {
                // show config inputs
                $('#custom').show();

                // if style placeholder is there
                if (document.getElementById('theme_overwrite')) {
                    // read current and apply
                    const inputPrimary = $('#primaryColor').val();
                    const inputStart= $('#startColor').val();
                    const inputEnd = $('#endColor').val();
                    themeOverwrite(inputPrimary, inputStart, inputEnd);
                }
            } else {
                // hide overwrite inputs
                $('#custom').hide()

                // reset overwrite css
                if (document.getElementById('theme_overwrite')) {
                    document.getElementById('theme_overwrite').innerHTML = '';
                }

                // change class
                document.body.classList = 'theme-' + value;
            }
        });
    }

    // realtime update css on change of custom colors
    $('#custom input[type="color"]').on('input', function () {
        const inputPrimary = $('#primaryColor').val();
        const inputStart= $('#startColor').val();
        const inputEnd = $('#endColor').val();
        themeOverwrite(inputPrimary, inputStart, inputEnd);
    });

    $('#textColorUnset').on('click', function(){
        if ($(this).is(':checked')) {
            $('#textColor').val('');
            $('#text_overwrite').html("");
        }
    })

    $('#textColor').on('input', function (e) {
        const color = e.target.value;
        $('#text_overwrite').html(":root { --ds-text: "+color+" !important; )");
        updateDerivedColorsFromHexVar('--ds-text');
        setHarmoniousColorVariants('--ds-text');
    });

    updateDerivedColorsFromHexVar('--ds-text');
    setHarmoniousColorVariants('--ds-text');
});
